import { PropertyType } from '@ha/algolia';
import type { TranslateFunc } from '@ha/intl';

import { LISTING_FACILITY_YES } from './constants';
import {
  LISTING_CARD_TITLE_TYPE_KEYS,
  LISTING_CARD_TITLE_WITH_STREET_KEY,
  LISTING_PROPERTY_TYPE_TRANSLATIONS,
} from './translations';

export type ListingCardTitleListing = {
  city: string;
  street?: string | null;
  recordType?: string | null;
  propertyType?: PropertyType | null;
  facility_co_living?: string | null;
  facility_student_housing?: string | null;
};

/**
 * Resolves the type label used in listing card titles.
 * PBSA labels apply only when `recordType === 'property'` (search card parity).
 */
export const getListingCardTitleTypeLabel = (
  listing: ListingCardTitleListing,
  T: TranslateFunc,
): string => {
  if (listing.recordType === 'property') {
    if (listing.facility_co_living === LISTING_FACILITY_YES) {
      return T(LISTING_CARD_TITLE_TYPE_KEYS.coLiving);
    }
    if (listing.facility_student_housing === LISTING_FACILITY_YES) {
      return T(LISTING_CARD_TITLE_TYPE_KEYS.studentHousing);
    }
  }

  if (!listing.propertyType || listing.propertyType === PropertyType.unknown) {
    return T(LISTING_CARD_TITLE_TYPE_KEYS.room);
  }

  return T(
    LISTING_PROPERTY_TYPE_TRANSLATIONS[listing.propertyType] ||
      LISTING_CARD_TITLE_TYPE_KEYS.room,
  );
};

/**
 * Full listing card title: `%(type)s in %(street)s, %(city)s`.
 */
export const getListingCardTitle = (
  listing: ListingCardTitleListing,
  T: TranslateFunc,
): string =>
  T(LISTING_CARD_TITLE_WITH_STREET_KEY, {
    type: getListingCardTitleTypeLabel(listing, T),
    street: listing.street ?? '',
    city: listing.city,
  });
